import React from 'react';
import { Link } from 'react-router-dom';
import { DateTimeFormat } from '../../helper/Formatters';
import { useLanguage } from '../../services/language/LanguageContext';

const StatusDot = ({ color, label }) => (
    <span style={{
        display: 'inline-flex', alignItems: 'center', gap: 5,
        padding: '2px 8px 2px 6px',
        background: color ? `${color}18` : '#f3f4f6',
        border: `1px solid ${color ? `${color}40` : '#e5e7eb'}`,
        borderRadius: 20, fontSize: 11, fontWeight: 600,
        color: color || '#6b7280', whiteSpace: 'nowrap',
    }}>
        <span style={{ width: 6, height: 6, borderRadius: '50%', background: color || '#9ca3af', flexShrink: 0 }} />
        {label || '-'}
    </span>
);

const RecentTransactionsBox = ({ data = [] }) => {
    const { t } = useLanguage();
    const transactions = Array.isArray(data) ? data : [];

    return (
        <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 14 }}>
                {t('recent_list')}
            </div>

            {transactions.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '28px 0', color: '#9ca3af', fontSize: 13 }}>
                    <i className="fa fa-inbox" style={{ fontSize: 22, marginBottom: 8, display: 'block', opacity: 0.3 }} />
                    {t('no_transactions')}
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                    {transactions.map((txn, idx) => (
                        <div key={txn.id} style={{ padding: '10px 0', borderBottom: idx < transactions.length - 1 ? '1px solid #f3f4f6' : 'none' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
                                <Link to={`/transactions/${txn.id}`} style={{ color: '#1e3a5f', fontWeight: 700, textDecoration: 'none', fontSize: 13 }}>
                                    #{txn.transactionNumber}
                                </Link>
                                <StatusDot color={txn.status?.color} label={txn.status?.labelTh} />
                            </div>
                            <div style={{ fontSize: 12, color: '#374151', marginBottom: 2 }}>
                                {txn.user ? `${txn.user.firstName || ''} ${txn.user.lastName || ''}`.trim() : '-'}
                            </div>
                            <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                {DateTimeFormat(txn.createDate)}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default RecentTransactionsBox;
